import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {InventoryReasonGroupService} from 'app/blocks/service/api/inventory-reason-group.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IInventoryReasonGroup} from 'app/blocks/model/inventory-reason-group.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {InventoryReasonGroup} from 'app/blocks/model/inventory-reason-group.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class InventoryReasonGroupResource extends AbstractEntityResource<IInventoryReasonGroup> {
    constructor(inventoryReasonGroupService: InventoryReasonGroupService, router: Router) {
        super(
            Resource.INVENTORY_REASON_GROUPS,
            inventoryReasonGroupService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.INVENTORY_REASON_GROUPS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.INVENTORY_REASON_GROUPS),
            (entity?) => new InventoryReasonGroup(entity),
            (entity) => entity.code
        );
    }
}
